import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/services/auth.service';
import { KeycloakAuthService } from 'src/app/services/keyclok-auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  logoImg=`../../../assets/imgs/logo/se2in_logo.png`;
  return: boolean = false;

  loginForm = {
    email: '',
    password: ''
  }
  constructor(
    private router:Router, 
    private authService:AuthService,
    private keykloakAuthService:KeycloakAuthService,
    private snackBar: MatSnackBar,
    private translateService: TranslateService
  ) { }


  ngOnInit(): void {
  }
  register(){
    this.router.navigate(['registration']);
  }
  forgetPassword(){}
  login(){

    console.log('login login.cmp', this.loginForm)
    if(this.loginForm){
      this.keykloakAuthService.login(this.loginForm).subscribe({
        next: (token) => {
        console.log('logged succesfully with token:',token)
          if(typeof token !=='undefined' && token && token !=='null'){
            console.log('logged succesfully with token:',token)

            const pendingAction = localStorage.getItem('postLoginAction');
            console.log('pendingAction', pendingAction)
            if (pendingAction) {
              const { type, path, appInfo } = JSON.parse(pendingAction);
              localStorage.removeItem('postLoginAction');
              if (type === 'CREATE_LXC') {
                this.router.navigate([path], {
                  state: { appInfo, type }
                });
                return;
              }
              if (type === 'STRIPE_PAYMENT') {
                this.router.navigate([path], {
                  state: { appInfo, type }
                });
                return;
              }
            }
            this.router.navigate(['/'])
          }
        },
        error: (error) => {
          console.error('Error logging in', error);
          this.showLoginErrorToast(error?.errorMessage);
        }
      })
    }
  }

  private showLoginErrorToast(errorMessage?: string): void {
    const message = errorMessage ?? '';

    if (message === 'NETWORK_ERROR' || this.isNetworkError(message)) {
      this.showErrorToast('NETWORK_ERROR', 'No internet connection. Please check your network and try again.');
      return;
    }

    const isInvalidCredentials = message.toLowerCase().includes('invalid user credentials')
      || message.toLowerCase().includes('invalid_grant')
      || message.toLowerCase().includes('invalid credentials');
    const i18nKey = isInvalidCredentials ? 'INVALID_CREDENTIALS' : 'LOGIN_FAILED';
    const fallback = isInvalidCredentials
      ? 'Invalid email or password.'
      : 'Login failed. Please try again.';
    this.showErrorToast(i18nKey, fallback);
  }

  private isNetworkError(message: string): boolean {
    const normalized = message.toLowerCase();
    return normalized.includes('network')
      || normalized.includes('internet')
      || normalized.includes('offline')
      || normalized.includes('err_internet');
  }

  private showErrorToast(i18nKey: string, fallback: string): void {
    this.translateService.get(i18nKey).subscribe({
      next: (translated: string) => {
        const message = translated === i18nKey ? fallback : translated;
        this.snackBar.open(message, 'Close', {
          duration: 8000,
          panelClass: ['my-custom-snackbar', 'snackbar-error'],
          horizontalPosition: 'center',
          verticalPosition: 'bottom',
        });
      },
      error: () => {
        this.snackBar.open(fallback, 'Close', {
          duration: 8000,
          panelClass: ['my-custom-snackbar', 'snackbar-error'],
          horizontalPosition: 'center',
          verticalPosition: 'bottom',
        });
      }
    });
  }

  loginWith(socialType:string){
    this.keykloakAuthService.signInWithSocial(socialType).subscribe((url:any)=>{
      if(url.trim(' ')){
        const popup = window.open(url);
        const messageListener = (event: MessageEvent) => {
          console.log('Get the token from another window', event.data)
          if(event.data?.type === 'SOCIAL_LOGIN_SUCCESS' && event.data.token){
            localStorage.setItem('token', event.data.token);
            window.removeEventListener('message', messageListener);
            const pendingAction = localStorage.getItem('postLoginAction');
            console.log('pendingAction signin with', pendingAction)
            if (pendingAction) {
              const { type, path, appInfo } = JSON.parse(pendingAction);
              localStorage.removeItem('postLoginAction');
              if (type === 'CREATE_LXC') {
                this.router.navigate([path], {
                  state: { appInfo, type }
                });
              }
              if (type === 'STRIPE_PAYMENT') {
                this.router.navigate([path], {
                  state: { appInfo, type }
                });
                return;
              }
            }else{
              this.router.navigate(['/'])
            }
          }
        };
        window.addEventListener('message', messageListener);
      }else{
        console.warn('No redirect URL returned');
      }
    });
  }
}
